import script from "./CrudActivosFijos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudActivosFijos.vue?vue&type=script&setup=true&lang=js"

import "./CrudActivosFijos.vue?vue&type=style&index=0&id=5f761e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f761e5c"]])

export default __exports__